export const imageUrls = {
  upsLogo:
    "https://sellar.imgix.net/sellar-image-assets/app-assets/ups-logo.png",
  dxLogo:
    "https://sellar.imgix.net/sellar-image-assets/app-assets/DX-logo1.png",
  apcLogo:
    "https://sellar.imgix.net/sellar-image-assets/app-assets/apc-logo.png",
  parcelforceLogo:
    "https://sellar.imgix.net/sellar-image-assets/app-assets/parcel-force-logo.svg",
  sellarLogo: {
    purple: {
      full: "https://sellar.imgix.net/sellar-image-assets/sellar-logo.svg",
    },
  },
};

type ImgixOptionsBase = {
  compress?: true;
};

export const generateImgixUrl = (
  imageUrl: string,
  options:
    | (ImgixOptionsBase & { width: number; height?: undefined })
    | (ImgixOptionsBase & { height: number; width?: undefined })
    | (ImgixOptionsBase & { height: number; width: number }),
) => {
  const url = new URL(imageUrl);
  if (
    url.protocol === "http:" &&
    (url.hostname === "imgix.net" || url.hostname.endsWith(".imgix.net"))
  ) {
    url.protocol = "https:";
  }
  if (url.pathname.toLowerCase().endsWith(".svg")) return url.href;
  if (options.compress) url.searchParams.append("auto", "compress");
  if (options.width) url.searchParams.append("w", options.width.toString());
  if (options.height) url.searchParams.append("h", options.height.toString());
  return url.href;
};
